import type * as React from 'react';

import type { NodeProps } from '@xyflow/react';
import type { Node } from '@xyflow/react';

import type { BaseNodeData, NodeDefinition } from '../../types';

import { FilterConfig } from './FilterConfig';
import { FilterNode, filterVisualDefinition } from './FilterNode';
import {
  FilterConfigType,
  defaultFilterConfig,
  validateFilterConfig,
  getFilterPreviewText,
} from './schema';

export { FilterNode } from './FilterNode';
export { FilterConfig } from './FilterConfig';
export type { FilterConfigType } from './schema';

/** Full definition for the registry */
export const filterDefinition: NodeDefinition<FilterConfigType> = {
  ...filterVisualDefinition,
  category: 'flow',
  paletteGroup: 'Flow Control',
  NodeComponent: FilterNode as unknown as React.ComponentType<
    NodeProps<Node<BaseNodeData>>
  >,
  ConfigComponent: FilterConfig,
  defaultConfig: () => ({ ...defaultFilterConfig }),
  validateConfig: validateFilterConfig,
  getPreviewText: getFilterPreviewText,
};
